<template>
  <EditableTable
      :data="data"
      :column-configs="columnConfigs"
  ></EditableTable>
</template>

<script>
  import EditableTable from "@/components/EditableTable";
  import {orderDetail} from "@/api";

  export default {
    name: "OrderDetail",
    components: {EditableTable},
    props: ['OID'],
    data() {
      return {
        data: [],
        columnConfigs: [
          {name: 'PID', alias: '編號', editable: false, needLevel: 0, width: '20%'},
          {name: 'PN', alias: '品名', editable: false, needLevel: 0, width: '60%'},
          {name: 'AMOUNT', alias: '數量', editable: false, needLevel: 0, width: '20%'},
        ]
      }
    },
    created() {
      orderDetail({OID: this.OID}).then(result => {
        console.log('detail', result);
        this.data = result.ORDER
      })
    }
  }
</script>

<style scoped>

</style>